<template>
    <Teleport to="body">
        <Transition name="slide-down">
            <div v-if="notificationState.show" class="top-notification-wrapper" @click="handleClick">
                <div class="top-notification-card">
                    <div class="notification-avatar">
                        <img :src="notificationState.avatar" :alt="notificationState.title" />
                    </div>
                    <div class="notification-content">
                        <div class="notification-title">{{ notificationState.title }}</div>
                        <div class="notification-description">{{ notificationState.description }}</div>
                    </div>
                    <div v-if="notificationState.badge" class="notification-badge">
                        {{ notificationState.badge }}
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { notificationState, hideTopNotification } from '@/composables/useTopNotification'

let timer: ReturnType<typeof setTimeout> | null = null

watch(() => notificationState.show, (newVal) => {
    if (newVal) {
        autoHide()
    }
})

const autoHide = () => {
    if (timer) {
        clearTimeout(timer)
    }
    if (notificationState.duration > 0) {
        timer = setTimeout(() => {
            hideTopNotification()
        }, notificationState.duration)
    }
}

const handleClick = () => {
    if (notificationState.onClick) {
        notificationState.onClick()
    }
    hideTopNotification()
}
</script>

<style scoped lang="scss">
.top-notification-wrapper {
    position: fixed;
    top: 20px;
    left: 16px;
    right: 16px;
    z-index: 9999;
    pointer-events: auto;
}

.top-notification-card {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: transform 0.2s ease;

    &:active {
        transform: scale(0.98);
    }
}

.notification-avatar {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.notification-content {
    flex: 1;
    min-width: 0;
}

.notification-title {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
    line-height: 22px;
    margin-bottom: 4px;
}

.notification-description {
    font-size: 14px;
    color: #999999;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.notification-badge {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #FF6B9D 0%, #FF8FB9 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    color: #FFFFFF;
    flex-shrink: 0;
}

// 动画
.slide-down-enter-active {
    animation: slideDown 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.slide-down-leave-active {
    animation: slideUp 0.3s ease-in;
}

@keyframes slideDown {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideUp {
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    100% {
        transform: translateY(-100%);
        opacity: 0;
    }
}
</style>

